import React, { type PropsWithChildren } from 'react';
import { AttachmentCountBadge } from '@/components/DiaryLessonCard/AttachmentCountBadge';

interface Props {
  title: string;
  attachmentCount?: number;
}

export const LessonSection: React.FC<PropsWithChildren<Props>> = ({
  title,
  attachmentCount = 0,
  children,
}) => (
  <>
    <div className="my-3 h-px bg-divider" />
    <div className="flex items-start justify-between gap-4">
      <span className="text-caption-13 text-foreground">{title}</span>
      {attachmentCount > 0 && <AttachmentCountBadge count={attachmentCount} />}
    </div>
    {children}
  </>
);
